import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Heading } from '@leroy-merlin-br/backyard-react'

import { Theme } from 'scripts/react-components/themes/Theme'

const carouselAndBadgesStyles = ({ theme }: Theme) => css`
  label: product-page__carousel-and-badges;

  display: flex;
  flex-direction: column-reverse;

  margin: ${theme.spacings.byte} 0px;

  ${theme.media.giga} {
    margin-top: 0px;
    margin-bottom: ${theme.spacings.mega};

    display: flex;
    flex-direction: column;
  }
`

const titleStyles = ({ theme }: Theme) => css`
  label: product-page__title;

  margin: ${theme.spacings.kilo};

  font-size: 13px;
  line-height: 20px;

  ${theme.media.mega} {
    font-size: 16px;
    margin-bottom: ${theme.spacings.mega};
  }
`

export const CarouselAndBadges = styled('div')(carouselAndBadgesStyles)
export const Title = styled(Heading)(titleStyles)
